/** @module csi/widget/SelectMenuRemovable */
define([
	"dojo/_base/declare",
	"dijit/form/_FormValueWidget",
	"dijit/form/Button",
	"dijit/_WidgetsInTemplateMixin",
	"csi/widget/FilteringSelect",
	"dojo/text!./SelectMenuRemovable.html"
], function(declare,_FormValueWidget,Button,_WidgetsInTemplateMixin,FilteringSelect,template) {

	return declare([_FormValueWidget,_WidgetsInTemplateMixin], {
		templateString: template,
		widgetType: "",
		
		// connection points
		focusNode: null,
		_selectNode: null,
		store: null,
		value: null,

		/**
		 * initialize and set focus node and store
		 */
		buildRendering: function(){
			this.inherited(arguments);
			this.focusNode = this._selectNode.focusNode;
			this._selectNode.set("store", this.store);
			this._selectNode.onChange = this.onChangeSelect;
		},
		
		/**
		 * Extension point for actions on delete
		 * @param {e} event
		 */
		onDelete:  function(e) { },
		
		validate: function() {
			return this._selectNode.validate();
		},
		
		/**
		 * Returns values from both widgets
		 */
		_getValueAttr: function() {
			var value = this._selectNode.get('value');
			return value;
		},
		
		/**
		 * focus on select Node
		 */
		focus: function() {
			this._selectNode.focus();
		},
		
		/**
		 * Sets the value to containing select widget
		 * @param {value} Value
		 * @param [priorityChange] Boolean
		 */
		_setValueAttr: function(value) {
			this._selectNode.set("value", value);
			this.inherited(arguments);
		},
		
		/**
		 * Extension point for on change select value
		 */
		onChangeSelect: function(val) {},
		
		/**
		 * Delete operation to remove the widget
		 * @param {e} event
		 */
		_onDelete: function(e) {
			this.onDelete(e);
			if(this._opened) {
				this.closeDropDown()
			}
			this.destroy();
		}
	});
});